module.exports = __webpack_public_path__ + "img/fuwu5.c2c0b986.jpg";